import React, {useEffect} from 'react';
import DocumentTitle from 'react-document-title';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import '../../assets/static/style';
import {Switch, Redirect} from "react-router-dom";
import routes from '../../routes';
import {useAuth0} from "../../services/auth0";
import {PrivateRoutes} from "../../helper/privateRoutes";
import {useSetRecoilState} from 'recoil';
import {userDetails} from "../../recoil_store";
import {getCurrentUserDetails} from "../../services/api.service";

const Home = ({getUser}) => {
    const {user, getTokenSilently, getIdTokenClaims} = useAuth0();
    const setRecoil = useSetRecoilState(userDetails);

    useEffect(() => {
        getUserDetails();
    });

    const getUserDetails = async () => {
        try {
            if (user) {
                const claims = await getIdTokenClaims();
                localStorage.setItem('accessToken', await getTokenSilently());
                setRecoil((userDetails) => ({...userDetails, loading: true}))
                const {data: {data}} = await getCurrentUserDetails(user.sub)
                setRecoil((userDetails) => ({...userDetails, ...data, ...user, loading: false}))
                localStorage.setItem('role', claims['https://paradi.io/access'] || "user");
            }
        } catch (err) {

        }
    };

    return (
        <React.Fragment>
            <Header key="header" className="show-shadow"/>
            <div className="wrapper">
                <Switch>
                    {
                        routes.map((route, id) => {
                            return route.component ? (
                                <PrivateRoutes key={id}
                                               path={route.path}
                                               exact={route.exact}
                                               name={route.name}
                                               auth={route.auth}
                                               role={route.roles}
                                               component={route.component}/>
                            ) : null
                        })
                    }
                    <Redirect from="/" to="/app-loading"/>
                    <Redirect from="*" to="/notfound"/>
                </Switch>
            </div>
            <Footer key="footer"/>
            <DocumentTitle title="Paradi"/>
        </React.Fragment>
    );
};

export default Home;